"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RealTimeNotificationConfiguration = exports.TrouterConfigClient = void 0;
const coreClient = __importStar(require("@azure/core-client")); // External library import
const core_rest_pipeline_1 = require("@azure/core-rest-pipeline"); // Grouped imports from the same module
const constants_1 = require("./constants");
class TrouterConfigClient extends coreClient.ServiceClient {
    constructor(endpoint, options) {
        // Initializing default values for options
        if (!options) {
            options = {};
        }
        const packageDetails = `azsdk-js-communication-signaling/${constants_1.PACKAGE_VERSION}`;
        const userAgentPrefix = options.userAgentOptions && options.userAgentOptions.userAgentPrefix
            ? `${options.userAgentOptions.userAgentPrefix} ${packageDetails}`
            : `${packageDetails}`;
        const clientOptions = Object.assign(Object.assign({}, options), { userAgentOptions: {
                userAgentPrefix,
            }, additionalPolicies: options.additionalPolicies });
        super(clientOptions);
        this.apiVersion = constants_1.CONFIG_API_VERSION;
        this.endpoint = endpoint;
        this.httpClient = (0, core_rest_pipeline_1.createDefaultHttpClient)();
    }
    fetchServiceUrls(credential) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const token = (yield credential.getToken()).token;
                const request = (0, core_rest_pipeline_1.createPipelineRequest)({
                    url: `${this.endpoint}/chat/config/realTimeNotifications?api-version=${this.apiVersion}`,
                    method: "GET",
                    headers: (0, core_rest_pipeline_1.createHttpHeaders)({
                        Authorization: `Bearer ${token}`,
                    }),
                });
                const response = yield this.pipeline.sendRequest(this.httpClient, request);
                if (response.status !== 200 || !response.bodyAsText) {
                    throw new Error(`Failed to fetch service URLs. Status: ${response.status}, Body: ${response.bodyAsText || "No response body"}`);
                }
                const data = JSON.parse(response.bodyAsText);
                // Ensure all necessary data fields are present
                if (!data.trouterServiceUrl || !data.registrarServiceUrl || !data.cloudType) {
                    throw new Error("One or more required fields are missing in the response data");
                }
                return new RealTimeNotificationConfiguration(data.trouterServiceUrl, data.registrarServiceUrl, data.cloudType);
            }
            catch (error) {
                throw new Error(`Error fetching real-time notification configuration from Chat Gateway: ${error.message}`);
            }
        });
    }
}
exports.TrouterConfigClient = TrouterConfigClient;
class RealTimeNotificationConfiguration {
    constructor(trouterServiceUrl, registrarServiceUrl, cloudType) {
        this.trouterServiceUrl = trouterServiceUrl;
        this.registrarServiceUrl = registrarServiceUrl;
        this.cloudType = cloudType;
    }
}
exports.RealTimeNotificationConfiguration = RealTimeNotificationConfiguration;
